/* Language dropdown. Plain disclosure pattern — no library, no dependency on
 * the nav's jQuery handlers. */
(function () {
  'use strict';

  /* Dwa dropdowny na tym samym wzorcu: jezyk i waluta. Skrypt obsluguje
   * kazdy z osobna, zeby otwarcie jednego nie ruszalo drugiego. */
  document.querySelectorAll('[data-lang-select]').forEach(function (select) {
  var toggle = select.querySelector('[data-lang-toggle]');
  var menu = select.querySelector('.lang_menu');
  if (!toggle || !menu) return;

  var arrow = select.querySelector('.lang_arrow');

  function open(on) {
    menu.hidden = !on;
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    // same class the FAQ accordion uses, so the arrow animates identically
    if (arrow) arrow.classList.toggle('is-active-accordion', on);
  }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    open(menu.hidden);
  });

  document.addEventListener('click', function (e) {
    if (!select.contains(e.target)) open(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) { open(false); toggle.focus(); }
  });
  });
})();
